import {
  formatPaymentMethod,
  formatNgn,
  isPayOnDeliveryOrder,
} from "../libs/orderDisplayUtils";
import "./orderPaymentBadges.css";

const OrderPaymentBadge = ({ order, showDue = false, className = "" }) => {
  if (!order) return null;

  const isPod = isPayOnDeliveryOrder(order);
  const label = formatPaymentMethod(order);
  const podPending = isPod && order.paymentStatus === "pending";

  return (
    <span className={`order-payment-badge-wrap ${className}`.trim()}>
      <span
        className={`order-payment-badge${isPod ? " order-payment-badge--pod" : ""}${
          order.paymentStatus === "paid" ? " order-payment-badge--paid" : ""
        }`}
      >
        {label}
      </span>
      {showDue && podPending && (
        <span className="order-payment-badge-due">
          Due at delivery: {formatNgn(order.totalAmount)}
        </span>
      )}
    </span>
  );
};

export default OrderPaymentBadge;

export const canCancelOrder = (order) => {
  if (!order || order.paymentStatus === "paid") return false;
  if (isPayOnDeliveryOrder(order)) {
    return ["Pending", "Processing"].includes(order.status);
  }
  return order.status === "Pending";
};
